/**
 * @description 全局Model articleInfoModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import {
  APIS,
  ParamsarticlePartIdUsingGet,
  ParamsthumbUpArticleIdUsingPost,
  CommonResultint,
  ParamsBodyuserFollowUsingPost,
  CommonResult,
  ArticleTotalVO,
  CommonResultArticleTotalVO,
  ParamsthumbUpArticleIdUsingDelete,
  ArticleVo,
  ArticleSimpleInfo,
  PointInfo,
  ParamsBodyshopCoinRewardUsingPost,
  UserRewardInfo,
  CommonResultArticleVo
} from '@src/services';
import { TkitUtils as Utils } from '@tkit/types';
import history from '@src/common/history';
import { message } from 'antd';

export interface State {
  articleInfoModel: {
    articleInfo: ArticleTotalVO;
    artEditInfo: ArticleVo;
    otherArts: ArticleSimpleInfo[];
    userPointInfo: PointInfo;
    userKcoin: number;
  };
}

export const articleInfoModelState: State = {
  articleInfoModel: {
    articleInfo: {},
    artEditInfo: {},
    otherArts: [],
    userPointInfo: {},
    userKcoin: 0
  }
};

const model = createModel({
  state: articleInfoModelState,
  namespace: 'articleInfoModel',
  reducers: {
    // 设置文章详情数据
    setArticleInfo: (state: any, action: Tction<{ articleInfo: ArticleTotalVO }>) => {
      return {
        ...state,
        articleInfoModel: {
          ...state.articleInfoModel,
          articleInfo: action.payload.articleInfo
        }
      };
    },
    setUserKcoin: (state: any, action: Tction<{ userKcoin: number }>) => {
      const { userKcoin } = action.payload;
      return {
        ...state,
        articleInfoModel: {
          ...state.articleInfoModel,
          userKcoin
        }
      };
    },
    updateComment: (state: any, action: Tction<{ count: number }>) => {
      return {
        ...state,
        articleInfoModel: {
          ...state.articleInfoModel,
          articleInfo: {
            ...state.articleInfoModel.articleInfo,
            comment: action.payload.count
          }
        }
      };
    },
    updateRewardList: (state: any, action: Tction<{ rewardUserList: UserRewardInfo[] }>) => {
      return {
        ...state,
        articleInfoModel: {
          ...state.articleInfoModel,
          articleInfo: {
            ...state.articleInfoModel.articleInfo,
            rewardUserList: action.payload.rewardUserList
          }
        }
      };
    },
    // 设置关注状态
    setFollowInfo: (state: any, action: Tction<{ followed: string }>) => {
      return {
        ...state,
        articleInfoModel: {
          ...state.articleInfoModel,
          articleInfo: {
            ...state.articleInfoModel.articleInfo,
            authorInfo: {
              ...state.articleInfoModel.articleInfo.authorInfo,
              followed: action.payload.followed
            }
          }
        }
      };
    },
    // 设置文章编辑信息
    setArtEditInfo: (state: any, action: Tction<ArticleVo>) => {
      const {
        articleInfoModel,
        articleInfoModel: { artEditInfo: oldInfo }
      } = state;

      const artEditInfo = {
        ...oldInfo,
        ...action.payload
      };

      return {
        ...state,
        articleInfoModel: {
          ...articleInfoModel,
          artEditInfo
        }
      };
    },
    // 设置文章是否收藏
    setArtCollectStatus: (state: any, action: Tction<boolean>) => {
      const {
        articleInfoModel,
        articleInfoModel: { articleInfo: oldInfo }
      } = state;
      const articleInfo = {
        ...oldInfo,
        hasCollect: action.payload
      };

      return {
        ...state,
        articleInfoModel: {
          ...articleInfoModel,
          articleInfo
        }
      };
    },
    // 设置作者更多文章
    setAuthorOtherArt: (state: any, action: Tction<ArticleSimpleInfo[]>) => {
      const { articleInfoModel } = state;

      return {
        ...state,
        articleInfoModel: {
          ...articleInfoModel,
          otherArts: action.payload
        }
      };
    },
    /** 设置用户积分信息 */
    setUserScore: (state, action: Tction<PointInfo>) => {
      const { articleInfoModel } = state;

      return {
        ...state,
        articleInfoModel: {
          ...articleInfoModel,
          userPointInfo: action.payload
        }
      };
    }
  },
  effects: {
    /**
     * 获取文章详情数据
     * @param param0
     * @param action
     */
    *getArticleInfoById(
      { tPut, tCall },
      action: Tction<{
        params: ParamsarticlePartIdUsingGet;
        callback?: (res: CommonResultArticleTotalVO) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.ArticleApi.articleIdUsingGet> = yield tCall(
        APIS.ArticleApi.articleIdUsingGet,
        params
      );

      if (res.code === 0) {
        // history.replace(`/common/error-handle-page`);
        yield tPut(model.actions.setArticleInfo, {
          articleInfo: (res && res.result) || {}
        });
        callback && callback(res);
      } else {
        message.error(res.message || '文章获取失败，建议重新刷新一下页面');
      }
    },
    /**
     * 点赞
     * @param param0
     * @param action
     */
    *thumbUp(
      { tPut, tCall },
      action: Tction<{
        params: ParamsthumbUpArticleIdUsingPost;
        callback: (res: CommonResultint) => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.ThumbUpApi.thumbUpArticleIdUsingPost> = yield tCall(
        APIS.ThumbUpApi.thumbUpArticleIdUsingPost,
        action.payload.params
      );
      if (res.code === 0) {
        action.payload.callback(res);
      }
    },
    /**
     * 取消点赞
     * @param param0
     * @param action
     */
    *cancelThumbUp(
      { tPut, tCall },
      action: Tction<{
        params: ParamsthumbUpArticleIdUsingDelete;
        callback: (res: CommonResultint) => void;
      }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.ThumbUpApi.thumbUpArticleIdUsingDelete> = yield tCall(
        APIS.ThumbUpApi.thumbUpArticleIdUsingDelete,
        action.payload.params
      );
      if (res.code === 0) {
        action.payload.callback(res);
      }
    },

    /**
     * 关注
     * @param param0
     * @param action
     */
    *follow(
      { tPut, tCall },
      action: Tction<{
        params: ParamsBodyuserFollowUsingPost;
        callback?: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callback } = action.payload;
      const res: Utils.GetROA<typeof APIS.UserApi.userFollowUsingPost> = yield tCall(
        APIS.UserApi.userFollowUsingPost,
        params
      );
      if (res.code === 0) {
        yield tPut(model.actions.setFollowInfo, {
          followed: String(params.ifFollow)
        });
      }
      callback && callback(res);
    },
    /**
     * 清空信息
     * @param param0
     * @param action
     */
    *cleanArticleInfo({ tPut, tCall }): Iterator<{}, any, any> {
      yield tPut(model.actions.setArticleInfo, {
        articleInfo: {}
      });
    },
    /**
     * @description 获取文章编辑信息
     */
    *getArtEditInfoAsync(
      { tPut, tCall },
      action: Tction<{ businessId: string; callBack?: (res: CommonResultArticleVo) => void }>
    ): Iterator<{}, any, any> {
      const { businessId, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.ArticleApi.articlePartNewBusinessIdUsingGet> = yield tCall(
        APIS.ArticleApi.articlePartNewBusinessIdUsingGet,
        action.payload
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setArtEditInfo, res.result);
        callBack && callBack(res);
      }
    },
    /**
     * @description 获取作者其他文章
     */
    *getAuthorOtherArtAsync(
      { tPut, tCall },
      action: Tction<{ articleId: number }>
    ): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.ArticleApi.articleArticleIdOthersUsingGet> = yield tCall(
        APIS.ArticleApi.articleArticleIdOthersUsingGet,
        action.payload
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setAuthorOtherArt, res.result);
      }
    },
    /**
     * @description 获取用户等级信息
     */
    *getUserScoreAsync(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: { username: string };
        callBack?: () => void;
      }>
    ): Iterator<{}, any, any> {
      const { params, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.PointApi.pointUsernameUsingGet> = yield tCall(
        APIS.PointApi.pointUsernameUsingGet,
        params
      );

      if (res.code === 0 && res.result) {
        yield tPut(model.actions.setUserScore, res.result);
        callBack && callBack();
      }
    },

    /** 保存到草稿 */
    *saveToAticles(
      { tPut, tCall },
      action: Tction<{ data: ArticleVo; callBack?: () => void }>
    ): Iterator<{}, any, any> {
      const { data, callBack } = action.payload;
      const res: Utils.GetROA<typeof APIS.ArticleApi.articleSaveNewUsingPut> = yield tCall(
        APIS.ArticleApi.articleSaveNewUsingPut,
        data
      );
      if (res.code === 0) {
        callBack && callBack();
        message.success('保存成功');
      } else {
        message.error(res.message);
      }
    },
    *getUserKcoin({ tPut, tCall }): Iterator<{}, any, any> {
      const res: Utils.GetROA<typeof APIS.ShopApi.shopPersonalAccountUsingGet> = yield tCall(
        APIS.ShopApi.shopPersonalAccountUsingGet
      );
      const { code, result } = res;
      if (code === 0) {
        yield tPut(model.actions.setUserKcoin, { userKcoin: result?.kcoin || 0 });
      } else {
        message.error(res.message);
      }
    },
    *getArtRewardList(
      { tPut, tCall },
      action: Tction<{
        params: ParamsarticlePartIdUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const { params } = action.payload;
      const res: Utils.GetROA<typeof APIS.ArticleApi.articleIdUsingGet> = yield tCall(
        APIS.ArticleApi.articleIdUsingGet,
        params
      );

      if (res.code === 0) {
        yield tPut(model.actions.updateRewardList, {
          rewardUserList: res.result?.rewardUserList || []
        });
      }
    },
    /** 文章赞赏 */
    *rewardUserArticle(
      { tPut, tCall },
      action: Tction<{
        data: ParamsBodyshopCoinRewardUsingPost;
        params: ParamsarticlePartIdUsingGet;
        callBack: (res: CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const { data, callBack, params } = action.payload;
      const res: Utils.GetROA<typeof APIS.ShopApi.shopCoinRewardUsingPost> = yield tCall(
        APIS.ShopApi.shopCoinRewardUsingPost,
        data
      );
      if (res.code === 0) {
        yield tPut(model.actions.getArtRewardList, { params });
        callBack(res);
      }
    }
  }
});

export default model;
